module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module id = PPGu
// module chunks = 1